// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const alexIntro = {
  alex_intro_page: {
    contentful_name: '[default] Alex Intro Page',
    header: '简介',
    sound_check_title: '你能听到我说话吗?',
    sound_check_buttons: ['是的,我能听到你说话。', '不,我听不到你说话。', '我现在不想使用声音。'],
    sound_off_text: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '此体验使用声音帮助您选择所有福利。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '如果您更喜欢无音频的福利概览,可以改用基于文本的体验获取帮助。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '否则,请在我们继续之前调高音量或使用上方的CC按钮打开字幕。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    sound_off_buttons: ['前往基于文本的体验。,继续使用声音/字幕。'],
    sound_off_text_without_go: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'This experience uses sound to help you choose all of your benefits. ',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Please turn up your sound or turn on closed captions using the CC button before we continue.',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    scenes2: [
      {
        contentful_name: '[default] Alex Video Scene',
        key: 'alexVideo',
        asset_type: 'video',
        asset_url:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
        video_asset_url:
          'https://videos.ctfassets.net/z0ugtcgrmslx/27HzebaTe7zzck8EODyxM0/df71887d7a8c3196c8c8ac36ef646401/bc_intro_page_logo.mp4',
        audio_asset_urls: [
          'https://picwellapppublicdata.s3.amazonaws.com/bc_intro_page_alex.mp3',
          'https://picwellapppublicdata.s3.amazonaws.com/bc_intro_page_courtesy.mp3',
        ],
        audio_delays: ['400', '300', '200'],
        transcript: '您好,我是ALEX。受您雇主委托为您服务。',
        return_user_audio_asset_urls: [
          'https://assets.ctfassets.net/z0ugtcgrmslx/6msPI1rqBdeyOZ3K2gC16G/6b69affd0a52df314bcc173cb4a5ce8b/INTRO_0166_04202022__1_.wav',
        ],
        return_user_transcript: '欢迎回来!你可能还记得,我是ALEX。',
      },
      {
        contentful_name: '[default] Sound Check Scene',
        key: 'hearMeAudio',
        asset_type: 'audio',
        asset_url: 'https://picwellapppublicdata.s3.amazonaws.com/SoundCheck.mp3',
        audio_asset_urls: ['https://picwellapppublicdata.s3.amazonaws.com/bc_intro_page_soundcheck.mp3'],
        audio_delays: ['200', '200'],
        transcript: '你能听到我说话吗?……现在呢?如果你需要时间调整音量,我可以播放一些音乐。[音乐播放中]',
        return_user_audio_asset_urls: [
          'I notice that the content to translate is empty - there is no text provided between the `<markdown>` tags.',
          'Please provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation following all the specified requirements.',
        ],
        return_user_transcript:
          'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      },
      {
        contentful_name: '[default] Sound Off Scene',
        key: 'soundOffAudio',
        asset_type: 'audio',
        asset_url:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
        transcript:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
        return_user_audio_asset_urls: [
          'I notice that the content to translate is empty - there is no text provided between the `<markdown>` tags.',
          'Please provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation following all the specified requirements.',
        ],
        return_user_transcript:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      },
      {
        contentful_name: '[default] Alex Outro Scene',
        key: 'askQuestionsVideo',
        asset_type: 'video',
        asset_url:
          'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
        video_asset_url:
          'https://videos.ctfassets.net/z0ugtcgrmslx/4DTvpJqkZI1QBlodKW9RPU/13bc8184b9c7784686158e4fce2b4c9f/bc_intro_page_intro_farmer.mp4',
        audio_asset_urls: [
          'https://assets.ctfassets.net/z0ugtcgrmslx/1A8yxWq7IUOqplAojQEtIK/c8c88e371918f920867fc94e49dcbfba/silence.mp3',
        ],
        audio_delays: ['500', '400', '300', '200'],
        transcript:
          '太好了!因为我要问你一些问题...帮你找到最适合的福利...然后也许我们可以想想这整件事对一个中世纪农民来说会有多困惑。对吧?但首先...',
        return_user_audio_asset_urls: [
          'I notice that no content was provided between the `<markdown>` tags for me to translate. The content area is empty.',
          'Please provide the English text you would like translated into Simplified Chinese, and I will complete the translation following your specifications.',
        ],
        return_user_transcript:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      },
      {
        contentful_name: '[default] Alex Outro Scene Juggling Joke',
        key: 'askQuestionsVideo1',
        asset_type: 'video',
        asset_url:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
        video_asset_url:
          'https://videos.ctfassets.net/z0ugtcgrmslx/6bpN4bC66b7Oh8Xz5qDKSl/24b62a8a4eee4af8893f030a4829a481/bc_intro_page_intro_juggling.mp4',
        audio_asset_urls: [
          'https://assets.ctfassets.net/z0ugtcgrmslx/1A8yxWq7IUOqplAojQEtIK/c8c88e371918f920867fc94e49dcbfba/silence.mp3',
        ],
        audio_delays: ['500', '400', '300', '200'],
        transcript:
          '太好了!因为我要问你几个问题……帮你找到最适合的福利……这样你就能回去做之前做的事了。让我猜猜……是杂耍吗?',
        return_user_audio_asset_urls: [
          'I notice that no content was provided between the `<markdown>` tags for me to translate. The content area is empty.',
          'Please provide the English text you would like translated into Simplified Chinese, and I will complete the translation following your specifications.',
        ],
        return_user_transcript:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
      },
      {
        contentful_name: '[default] Alex Outro Scene Sleep Joke',
        key: 'askQuestionsVideo2',
        asset_type: 'video',
        asset_url:
          'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
        video_asset_url:
          'https://videos.ctfassets.net/z0ugtcgrmslx/Yl06raQWbznniQmQnWUsW/a9f697ed65a6ce03277460e51dd07f91/bc_intro_page_intro_sleep.mp4',
        audio_asset_urls: [
          'https://assets.ctfassets.net/z0ugtcgrmslx/1A8yxWq7IUOqplAojQEtIK/c8c88e371918f920867fc94e49dcbfba/silence.mp3',
        ],
        audio_delays: ['500', '400', '300', '200'],
        transcript:
          '太好了!因为我要问你一些问题……帮你找到最适合你的福利……这样你就能安心入睡,对自己的选择充满信心。不过不是现在!先别睡,听我说完。',
        return_user_audio_asset_urls: [
          'I notice that no content was provided between the `<markdown>` tags for me to translate. The content area is empty.',
          'Please provide the English text you would like translated into Simplified Chinese, and I will complete the translation following your specifications.',
        ],
        return_user_transcript:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      },
      {
        contentful_name: '[default] Alex Outro Scene Nap Joke',
        key: 'askQuestionsVideo3',
        asset_type: 'video',
        asset_url:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
        video_asset_url:
          'https://videos.ctfassets.net/z0ugtcgrmslx/6rTo6xQoqKjXbN2YKtT4BX/d8ed74c975f92cf65674f8ab124091c2/bc_intro_page_intro_nap.mp4',
        audio_asset_urls: [
          'https://assets.ctfassets.net/z0ugtcgrmslx/1A8yxWq7IUOqplAojQEtIK/c8c88e371918f920867fc94e49dcbfba/silence.mp3',
        ],
        audio_delays: ['500', '400', '300', '200'],
        transcript:
          '太好了!因为我要问您一些问题...帮您找到最适合的福利...然后也许您可以偷偷打个盹。我不会告诉别人的。',
        return_user_audio_asset_urls: [
          'I notice that no content was provided between the `<markdown>` tags for me to translate. The content area is empty.',
          "Please provide the English text you would like translated into Simplified Chinese, and I will complete the translation following the requirements you've specified.",
        ],
        return_user_transcript:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      },
      {
        contentful_name: '[default] Alex Outro Scene Clapping Joke',
        key: 'askQuestionsVideo4',
        asset_type: 'video',
        asset_url:
          'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
        video_asset_url:
          'https://videos.ctfassets.net/z0ugtcgrmslx/34B99iJA8rZoWXkDxSyeQC/390aba3b6961606b7b738358d20304e5/bc_intro_page_intro_clap.mp4',
        audio_asset_urls: [
          'https://assets.ctfassets.net/z0ugtcgrmslx/1A8yxWq7IUOqplAojQEtIK/c8c88e371918f920867fc94e49dcbfba/silence.mp3',
        ],
        audio_delays: ['500', '400', '300', '200'],
        transcript:
          '太好了!因为我要问你一些问题……帮你找到最适合的福利……然后我们一起鼓掌。[糟糕的掌声]好吧,显然我们还没热身呢。',
        return_user_audio_asset_urls: [
          'I notice that the content to translate is empty - there is no text provided between the `<markdown>` tags.',
          'Please provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation following all the specified requirements.',
        ],
        return_user_transcript:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      },
      {
        contentful_name: '[default] Alex Outro Scene Original Joke',
        key: 'askQuestionsVideo5',
        asset_type: 'video',
        asset_url:
          'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
        video_asset_url:
          'https://videos.ctfassets.net/z0ugtcgrmslx/4DTvpJqkZI1QBlodKW9RPU/13bc8184b9c7784686158e4fce2b4c9f/bc_intro_page_intro_farmer.mp4',
        audio_asset_urls: [
          'https://assets.ctfassets.net/z0ugtcgrmslx/1A8yxWq7IUOqplAojQEtIK/c8c88e371918f920867fc94e49dcbfba/silence.mp3',
        ],
        audio_delays: ['500', '400', '300', '200'],
        transcript:
          '太好了!因为我要问你一些问题……帮你找到最适合的福利……然后也许我们可以想想这整件事对中世纪农民来说会有多困惑。对吧?但首先……',
        return_user_audio_asset_urls: [
          'I notice that no content was provided between the `<markdown>` tags for me to translate. The content area is empty.',
          'Please provide the English text you would like translated into Simplified Chinese, and I will complete the translation following your specifications.',
        ],
        return_user_transcript:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      },
    ],
  },
};
